export interface HeaderMenu {
  title: string;
  url?: string;
  action?: () => void;
  subMenus?: {
    title: string;
    url?: string;
    action?: () => void;
  }[];
}

export const menu: HeaderMenu[] = [
  {
    title: 'Giải pháp',
    url: '/#solutions',
  },
  {
    title: 'Tính năng',
    url: '/#features',
    // subMenus: [
    //   {
    //     title: 'utilities',
    //     url: '/#utilities',
    //   },
    //   {
    //     title: 'features',
    //     url: '/#features',
    //   },
    // ],
  },
  {
    title: 'Bảng giá',
    url: '/#pricing',
  },
  {
    title: 'Sổ tay',
    url: '/docs/',
  },
  {
    title: 'Bài viết',
    url: '/blogs/p/1/',
  },
  // {
  //   title: 'Về chúng tôi',
  //   url: '/about',
  // },
];

export const getLanguageFlag = (locale?: string) => {
  switch (locale) {
    case 'vi':
      return '🇻🇳';
    default:
      return '🇬🇧';
  }
};
